import {
    SUPPLIER_FILTER,
    SUPPLIER_TYPE_FILTER,
} from '../constants/ActionTypes';

const initialState = {
    supplierFilter: "",
    supplierTypeSelected: "",
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
    switch (action.type) {
        case SUPPLIER_FILTER:
            return {
                ...state,
                supplierSelected: action.payload
            }
        case SUPPLIER_TYPE_FILTER:
            return {
                ...state,
                supplierTypeSelected: action.payload
            }
        default:
            return state;
    }
}